import React from 'react';
import { Link as ReactRouterLink, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import {
  Box,
  HStack,
  Icon,
  Link,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FaChevronRight } from 'react-icons/fa';

import {
  CATEGORY_WITH_EVENT_COMPETITIONS,
  COMPETITION_STATS,
  FETCH_EVENT_HEADER,
} from '../../GraphQL/Queries';
import useHeaderComponentsMutation from '../../Hooks/useHeaderComponentsMutation';
import useCurrentUser from '../../Hooks/userCurrentUser';
import Loader from '../../Components/Loader';
import { EVENT_TITLE } from '../../Constants/AppConstants';
import { CompetitionReportExport } from './CompetitionReportExport';
import { Provider } from '../../Chakra/provider';

const CompetitionsByEvent = () => {
  const {
    currentUser,
  } = useCurrentUser(true);
  const { id } = useParams();

  const { data, loading } = useQuery(FETCH_EVENT_HEADER, {
    variables: {
      id: parseInt(id, 10),
    },
    skip: !currentUser,
  });
  const event = data?.fetchEventDetail ?? {};

  const { data: count } = useQuery(
    COMPETITION_STATS,
    {
      variables: { eventId: parseInt(id, 10) },
    },
  );
  const studentsAndCompetitionsCount = count?.competitionStats ?? {};

  const { data: categoriesData, loading: competitionsLoading } = useQuery(
    CATEGORY_WITH_EVENT_COMPETITIONS, {
      variables: {
        eventId: parseInt(id, 10),
      },
      skip: !currentUser,
    },
  );
  const categoryCompetitions = categoriesData?.categoryWithEventCompetitions;

  useHeaderComponentsMutation({
    title: 'Competitions REPORTS',
    backLink: `/event-manage/${id}`,
    components: [{ key: EVENT_TITLE, value: event.title }],
  });


  if (loading || competitionsLoading) {
    return <Loader />;
  }

  return (
    <Provider>
      <VStack spacing={4} paddingBlockStart={4}>
        <HStack justifyContent="space-around" width="100%">
          <VStack>
            <Text fontSize="2xl" fontWeight="bold">{studentsAndCompetitionsCount?.student}</Text>
            <Text>Students</Text>
          </VStack>
          <VStack>
            <Text fontSize="2xl" fontWeight="bold">{studentsAndCompetitionsCount?.competition}</Text>
            <Text>Competitions</Text>
          </VStack>
        </HStack>
        <span style={{ width: '100%' }}>
          <CompetitionReportExport
            categories={categoryCompetitions}
            filename={`${event.title} Competitions`}
            includeRegionColumn={event.qualifiedAttendingPreviousEvent}
          />
        </span>
        {categoryCompetitions && categoryCompetitions.map((category, categoryIdx) => (
          <Box key={category?.id} width="100%" paddingBlock={1}>
            <Text fontWeight="bold">
              {category?.title}
            </Text>
            {category?.eventCompetitions && category.eventCompetitions.map((competition, idx) => {
              const isLastCategory = categoryIdx === categoryCompetitions.length - 1;
              const isLastCompetition = idx === category.eventCompetitions.length - 1;
              const includeBorder = !(isLastCategory && isLastCompetition);
              return (
                <React.Fragment key={competition?.id}>
                  <Link as={ReactRouterLink} to={`/events/${id}/competitions/${competition?.id}`}>
                    <HStack width="100%" justifyContent="space-between" paddingBlock={2} marginBlockStart={1} borderBlockEnd={includeBorder ? 1 : 0} borderStyle="solid" borderColor="gray.200">
                      <Text>
                        {competition.title}
                      </Text>
                      <HStack>
                        <Text>
                          {competition.joinedMemberCount}
                        </Text>
                        <Icon as={FaChevronRight} />
                      </HStack>
                    </HStack>
                  </Link>
                </React.Fragment>
              );
            })}
          </Box>
        ))}
      </VStack>
    </Provider>
  );
};
export default CompetitionsByEvent;
